import { render, staticRenderFns } from "./GuideBoardTable.vue?vue&type=template&id=56dee1ff&"
import script from "./GuideBoardTable.vue?vue&type=script&lang=js&"
export * from "./GuideBoardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports